import { getPriceForTokenByTokenList } from "../utils/tokenListUtils";
import { Amount } from "../types/amount";
import { SelectedToken } from "../store/global/GlobalStore";
import { useTokenListByChain } from "./useTokenListByChain";
import { QuoteTokens } from "../types/quote";

export function useTotalUSDAmount(
  tokens: Array<SelectedToken>,
  isMakerSide: boolean,
  quoteTokens?: QuoteTokens
) {
  const tokenList = useTokenListByChain();

  if (tokens && tokenList) {
    const newTotalUSDAmount = tokens.reduce((total, token) => {
      const symbol = token.token;
      const inputAmount = token.amount;
      const quoteAmount = isMakerSide
        ? quoteTokens?.[symbol]?.amountBeforeFee
        : quoteTokens?.[symbol]?.amount;
      const amount = quoteAmount ?? inputAmount;
      const tokenListPrice = getPriceForTokenByTokenList(symbol, tokenList);
      const quotePrice = quoteTokens?.[symbol]?.priceUsd;
      const price = quotePrice ?? tokenListPrice;
      const usdValue = price.mul(amount);
      return total.add(usdValue);
    }, Amount.ZERO);

    return newTotalUSDAmount;
  }
  return Amount.ZERO;
}
